<template>
  <div class="index-footer">
    <div class="index-footer_box">
      <el-row>
        <el-col :span="10">
          <!-- <img src="./../../assets/img/logo_green.png" alt /> -->
          <span
            class="span1"
          ><i @click="introduce">业务介绍</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="about">关于扬海</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="consultation">资讯中心</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="contact">联系我们</i></span>
        </el-col>
        <el-col :span="6">
          <div class="notice_right_news">
            <div class="notice_right_phone">400-800-1271</div>
            <div class="notice_right_title">扬海资产客户专线</div>
            <div class="notice_right_border"></div>
            <div class="notice_right_data1">service</div>
            <div class="notice_right_data2">9:00 - 20:00（7*10小时）</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="index-footer_code">
            <el-row>
              <el-col :span="8">
                <img src="./../../assets/img/img-code01.png" alt />
              </el-col>
              <el-col :span="16">
                <div class="index-footer_wexin">
                  <span>关注微信公众号</span>
                  <p>了解我们更多的信息及还款方式</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="index-footer_bom">
      <div class="index-footer_bom_box">@2019 - 2029 扬海资产 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2020030464号-1</a></div>
    </div>
  </div>
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    introduce(){
      let that = this;
      that.$router.push({name:'introduce'})
    },
    consultation(){
      let that = this;
      that.$router.push({name:'consultation'})
    },
    about(){
      let that = this;
      that.$router.push({name:'about'})
    },
    contact(){
      let that = this;
      that.$router.push({name:'contact'})
    }
  },
  created(){
  }
};
</script>
<style>
.index-footer {
  background: #fff;
  border-top: rgba(34, 34, 34, 0.1) solid 1px;
  position: relative;
    bottom: 0;
}
.index-footer_box {
  padding: 47px 260px;
}
.index-footer_bom  .index-footer_bom_box {
  padding: 0px 260px;
  font-size:12px;
  font-family:MicrosoftYaHei;
  color:rgba(154,154,154,1);
  line-height: 36px;
}
.index-footer_bom{
  background: rgba(247, 247, 247, 1);
}
.index-footer_box .span1 i{
  cursor: pointer;
}
.index-footer_box .span1 {
  display: inline-block;
  padding-top: 30px;
}
.notice_right_news {
  display: inline-block;
  border-left: rgba(34, 34, 34, 0.1) solid 1px;
  padding: 0 60px;
  border-right: rgba(34, 34, 34, 0.1) solid 1px;
}
.notice_right_news .notice_right_phone {
  height: 36px;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 36px;
}
.notice_right_news .notice_right_title {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 16px;
}
.notice_right_news .notice_right_border {
  width: 15px;
  height: 2px;
  background: rgba(34, 34, 34, 1);
  margin: 10px 0 12px 0;
}
.notice_right_news .notice_right_data1 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 8px;
}
.notice_right_news .notice_right_data2 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 20px;
}
.notice_right_news .notice_content {
  width: 1px;
  height: 115px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.5;
}
.index-footer_code img {
  /* width: 78px; */
  display: inline-block;
}
.index-footer_code .index-footer_wexin {
  padding-top: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/comFooter.vue